export enum GridLayout {
  'cols-1' = 'cols-1',
  'cols-2' = 'cols-2',
  'cols-30-70' = 'cols-30-70',
  'cols-70-30' = 'cols-70-30',
  'cols-25-75' = 'cols-25-75',
  'cols-75-25' = 'cols-75-25',
  'cols-3' = 'cols-3',
  'cols-4' = 'cols-4',
}
export enum GridColumnKey {
  column1 = 'column1',
  column2 = 'column2',
  column3 = 'column3',
  column4 = 'column4',
}

export const layoutColumnKeys: Record<GridLayout, GridColumnKey[]> = {
  [GridLayout['cols-1']]: [GridColumnKey['column1']],
  [GridLayout['cols-2']]: [GridColumnKey['column1'], GridColumnKey['column2']],
  [GridLayout['cols-30-70']]: [GridColumnKey['column1'], GridColumnKey['column2']],
  [GridLayout['cols-70-30']]: [GridColumnKey['column1'], GridColumnKey['column2']],
  [GridLayout['cols-25-75']]: [GridColumnKey['column1'], GridColumnKey['column2']],
  [GridLayout['cols-75-25']]: [GridColumnKey['column1'], GridColumnKey['column2']],
  [GridLayout['cols-3']]: [
    GridColumnKey['column1'],
    GridColumnKey['column2'],
    GridColumnKey['column3'],
  ],
  [GridLayout['cols-4']]: [
    GridColumnKey['column1'],
    GridColumnKey['column2'],
    GridColumnKey['column3'],
    GridColumnKey['column4'],
  ],
};
